import { render, staticRenderFns } from "./SupplierTotalDueNumberDisplayer.vue?vue&type=template&id=c55fad30"
import script from "./SupplierTotalDueNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./SupplierTotalDueNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports